<template>
  <div>
    <material-card-custom
      style="z-index: 2"
      :size.sync="internalSize"
      :isPensions="true"
      :height.sync="internalHeight"
      :order.sync="internalOrder"
      :maxOrderValue="maxOrderValue"
      :widgetId="widgetId"
      color="primary"
      @remove-widget="$emit('remove-widget', $event)"
      @add-widget="$emit('add-widget', $event)"
      :title="$t('components.vue_material_dashboard.items.my_balance.title')"
    >
      <v-card height="432" flat class="rounded-t-0" light>
        <v-card-title class="font-weight-medium pb-0">{{
          $t("components.vue_material_dashboard.items.my_balance.subtitle")
        }}</v-card-title>

        <div class="pt-12 mt-12">
          <v-list>
            <!-- <v-list-item>
            <v-list-item-content class="text-center font-weight-bold py-0 mt-8">
              <v-col cols="12" class="pb-0"
                >{{
                  $t(
                    "components.vue_material_dashboard.items.my_balance.current_balance"
                  )
                }}
              </v-col>
              <v-col cols="12" class="primary--text" v-if="loading">
                <v-progress-circular indeterminate></v-progress-circular>
              </v-col>
            </v-list-item-content>
          </v-list-item> -->
            <v-divider class="mx-5 my-1"></v-divider>
            <!-- <v-list-item>
            <v-list-item-content class="text-left font-weight-bold py-0">
              <v-col class="text-h6 font-weight-medium">{{
                $t("components.vue_material_dashboard.items.my_balance.total")
              }}</v-col>
              <v-col class="text-h5 monthly-pension primary--text text-center">
                {{
                  $helpers.toCurrency(
                    assetsData?.PlanInfo?.Summary?.CurrentBalance
                  )
                }}
              </v-col>
              <v-col cols="12" class="primary--text" v-if="loading">
                <v-progress-circular indeterminate></v-progress-circular>
              </v-col>
            </v-list-item-content>
          </v-list-item> -->
            <!-- <v-divider class="mx-4 my-1"></v-divider> -->
            <v-list-item>
              <v-list-item-content class="text-left py-0">
                <v-col cols="12" class="font-weight-bold text-center">{{
                  $t(
                    "components.vue_material_dashboard.items.my_balance.amount_of_december"
                  )
                }}</v-col>
                <v-col
                  class="text-h5 monthly-pension primary--text text-center pt-0"
                >
                  {{
                    $helpers.toCurrency(assetsData?.PlanInfo?.Summary?.Total)
                  }}
                </v-col>
                <!-- <v-col cols="12" class="primary--text" v-if="loading">
                <v-progress-circular indeterminate></v-progress-circular>
              </v-col> -->
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="assetsData.PlanInfo?.Summary"
              class="mx-4 my-1"
            ></v-divider>
          </v-list>
        </div>
      </v-card>
      <v-row no-gutters class="bottom-btn">
        <v-btn
          class="secondary lighten-2 mt-2 mt-sm-7"
          width="150px"
          to="balance"
          >{{
            $t("components.vue_material_dashboard.items.my_pension.see_details")
          }}</v-btn
        >
      </v-row>
    </material-card-custom>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import MaterialCardCustom from "@/components/VueMaterialDashboard/material/MaterialCardCustomDashboard.vue";
export default {
  components: {
    MaterialCardCustom,
  },
  props: {
    widgetId: String,
    size: Number,
    height: Number,
    order: Number,
    maxOrderValue: Number,
  },
  data() {
    return {
      internalSize: undefined,
      internalHeight: undefined,
      internalOrder: undefined,
      assetsData: {},
      loading: false,
      printPdf: false,
      savePdf: false,
      reportData: null,
      pastYear: moment().year() - 1,
    };
  },
  watch: {
    size: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalSize: {
      handler(v) {
        this.$emit("update:size", v);
      },
    },
    height: {
      handler(v) {
        this.internalHeight = v;
      },
    },
    internalHeight: {
      handler(v) {
        this.$emit("update:height", v);
      },
    },
    order: {
      handler(v) {
        this.internalOrder = v;
      },
    },
    internalOrder: {
      handler(v) {
        this.$emit("update-order", v);
      },
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  mounted() {
    if (this.size !== null && this.size !== undefined) {
      this.internalSize = this.size;
    }
    if (this.height !== null && this.height !== undefined) {
      this.internalHeight = this.height;
    }
    if (this.order !== null && this.order !== undefined) {
      this.internalOrder = this.order;
    }
    this.loadData();
  },
  methods: {
    ...mapActions("data", ["getAssetsData"]),
    async loadData() {
      try {
        this.loading = true;
        this.assetsData = (
          await this.getAssetsData({
            planIdentityId: this.user.plan,
            memberIdentityId: this.user.sub,
          })
        )?.data;
        this.loading = false;
      } catch (error) {
        this.error = error;
        console.log(error);
        // this.assetsData = {
        //   CurrentBalance: 43356,
        //   RRP: 88353.67,
        //   Total: 88353.67,
        //   BalancedDiversified: 13.42,
        //   FixedIncome: 11.37,
        //   Equity: 75.21,
        // };
        this.loading = false;
      }
    },
    downloadReport() {
      console.log("Download Report");
    },
    viewReport() {
      console.log("View Report");
    },
    print() {
      console.log("Print Report");
      this.printPdf = true;
    },
  },
};
</script>
<style scoped>
.printer-icon {
  position: absolute !important;
  top: 15px;
  right: 15px;
}
.bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.monthly-pension {
  font-weight: 600 !important;
}
</style>
